module.exports = __webpack_public_path__ + "035a0199d61cce9658e38155b097d3c3.png";